__turbopack_context__.v({
  "bar": "UJL8Lq_bar",
  "nav": "UJL8Lq_nav",
  "row": "UJL8Lq_row",
  "share": "UJL8Lq_share",
  "tab": "UJL8Lq_tab",
});
